module.exports = __webpack_public_path__ + "img/8.4b1c1608.png";